import React from "react";
import ShowMore from "../common/ShowMore";
import BusinessCardSkeleton from "../common/BusinessCardSkeleton";
import axios from "axios";
import DefaultBL from "../../gallery/default/defaultBusinessLogo.png";
import BusinessCard from "../common/BusinessCard";
import { useQuery } from "react-query";

const FeaturedBusiness = React.memo(function FeaturedBusiness() {
  const { data, isLoading } = useQuery({
    queryKey: ["featuredBusiness"],
    queryFn: async () => {
      const options = {
        method: "GET",
        url: process.env.REACT_APP_BASE_URL + "/api/business",
        headers: {
          Authorization: process.env.REACT_APP_API_KEY,
        },
        params: {
          list: "featured",
        },
      };

      const response = await axios.request(options);
      return response.data.data;
    },
  });

  /* console.log(data) */
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
          <h3 className="featured-business-title">Featured Businesses</h3>
        </div>
        {isLoading
          ? // Show 3 skeleton cards while loading
            Array.from({ length: 3 }).map((_, index) => (
              <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 card-holder" key={`skeleton-${index}`}>
                <BusinessCardSkeleton />
              </div>
            ))
          : data &&
            data.map((element, index) => {
              return (
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 card-holder" key={index}>
                  <BusinessCard imgaeWidth="305px" imageHeight="75px" align={"align-items-start"} justifycontent={"left"} image={element.image_thumbnail_path ? element.image_thumbnail_path : DefaultBL} title={element.name ? element.name : ""} location={element.location ? element.location : ""} postalcode={element.postal_code ? element.postal_code : ""} address={element.postal_code ? element.postal_code : ""} page={element.page ? element.page : ""} type={element.category ? element.category.charAt(0).toUpperCase() + element.category.slice(1) : ""} category_id={element.category_id} detail_url={element.page + "/" + element.slug} views={element.views} RemoveBodyPaddingBottom={true} />
                </div>
              );
            })}
        <ShowMore url={"/search?category=1&location=1&page=1&limit=10"} />
      </div>
    </div>
  );
});

export default FeaturedBusiness;
